/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { Unrecognized, unrecognized } from "./unrecognized.js";

export type ClosedEnum<T extends Readonly<Record<string, string | number>>> =
  T[keyof T];
export type OpenEnum<T extends Readonly<Record<string, string | number>>> =
  | T[keyof T]
  | Unrecognized<T[keyof T] extends number ? number : string>;

export function inboundSchema<T extends Record<string, string>>(
  enumObj: T,
): z.ZodMiniType<OpenEnum<T>, unknown> {
  const options = Object.values(enumObj);
  return z.union([
    ...options.map(x => z.literal(x)),
    z.pipe(z.string(), z.transform(x => unrecognized(x))),
  ] as any);
}

export function inboundSchemaInt<T extends Record<string, number | string>>(
  enumObj: T,
): z.ZodMiniType<OpenEnum<T>, unknown> {
  // For numeric enums, Object.values returns both numbers and string keys
  const options = Object.values(enumObj).filter(v => typeof v === "number");
  return z.union([
    ...options.map(x => z.literal(x)),
    z.pipe(z.int(), z.transform(x => unrecognized(x))),
  ] as any);
}

export function outboundSchema<T extends Record<string, string>>(
  _: T,
): z.ZodMiniType<string, OpenEnum<T>> {
  return z.string() as any;
}

export function outboundSchemaInt<T extends Record<string, number | string>>(
  _: T,
): z.ZodMiniType<number, OpenEnum<T>> {
  return z.int() as any;
}
